import 'styles/tailwind.css';
// Exclude test files from compilation - https://github.com/rails/webpacker/issues/1818
var componentRequireContext = require.context('components', true, /^(?!.*(test|stories).*).*$/);
var ReactRailsUJS = require('react_ujs');
ReactRailsUJS.useContext(componentRequireContext);
